import React, { useState, useEffect, useRef } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Box,
  Button,
  Text,
  Image,
  VStack,
  HStack,
  Radio,
  Input,
  RadioGroup,
  Wrap,
  WrapItem,
  SimpleGrid,
  Textarea,
} from "@chakra-ui/react";
import useLoader from "../../loader/loaderstates";
import Loader from "../../loader/loader";
import {
  GetDoctorMasterData,
  GetDoctorNotes,
  updateDoctorNotes,
} from "../../../middleware/services/visits/patient-overview/updatedoctornotes";
import { COLORS } from "../../styles/colors";
import PrimaryButton from "../../primary-button";
import { actionAccessMain } from "../../../auth";
import { useGPUTranscriber } from "./cheif-complaint-audio/useGPUTranscriber";
import { GPUChatAudioManager } from "./cheif-complaint-audio/gpuChatVoiceManager";
import { FaPlus } from "react-icons/fa6";
import { FiMinus } from "react-icons/fi";
import { CorrectChiefComplaintUsingAI, CorrectMedicalTermsUsingAI } from "../../../middleware/services/visits/aicalls";
import { useHybridTranscriber } from "./cheif-complaint-audio/useHybridTranscriber";
import { GPUChatAudioManagerSpeechMode } from "./cheif-complaint-audio/gpuChatVoiceManagerSpeechMode";

const DoctorPhysicalExamCard = ({
  patientId,
  doctorId,
  appointmentId,
  showSuccessToast,
  showErrorToast,
  fetchDoctorNotesEmptyIndication,
  submitOnTabSwitch
}) => {
  const [selectedConditions, setSelectedConditions] = useState([]);
  const [initiallySelectedConditions, setInitiallySelectedConditions] =
    useState([]);

  const [doctorMasterPhysicalExamData, setDoctorMasterPhysicalExamData] =
    useState([]);
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const [sectionDescriptions, setSectionDescriptions] = useState({});
  const [initialDescriptions, setInitialDescriptions] = useState({});
const aiModifiedRef = useRef(false);

  useEffect(() => {
    fetchDoctorNotes().then(() => {
      fetchPhysicalExamMasterData();
    });
  }, []);

  const transformPhysicalExamData = (inputData) => {
    const transformedData = [];

    // Iterate through each group of physical exams
    inputData.forEach((group) => {
      const { type, physicalexam } = group;

      // Map through physicalexam array and transform it to the desired structure
      physicalexam.forEach((exam) => {
        const { examvalue, subexamkey, nestedexamkey, indicator } = exam;

        // Push each transformed object to the result array
        transformedData.push({
          examkey: type, // Type from the group
          subexamkey: subexamkey || null, // If subexamkey is null, set it as null
          nestedKey: nestedexamkey || null, // If nestedexamkey is null, set it as null
          indicator: indicator || 0, // Set indicator default to 0 if not provided
          examvalue: examvalue, // Exam value remains unchanged
        });
      });
    });

    return transformedData;
  };

  const fetchDoctorNotes = async () => {
    const inputToFetch = {
      input: {
        patientid: patientId,
        doctorid: doctorId,
        appointmentid: appointmentId,
      },
    };
    showLoader();
    try {
      const data = await GetDoctorNotes(inputToFetch.input);
      const physicalExam = data?.output?.data?.physicalexam || [];
      const initialSelectedConditions = transformPhysicalExamData(physicalExam);
      // console.log("Initially Selected: ", initialSelectedConditions);
      setSelectedConditions(initialSelectedConditions);
      setInitiallySelectedConditions(initialSelectedConditions);
      setTextFieldValue(data?.output?.data?.physicalexamtext?.description);
      setDefaultText(data?.output?.data?.physicalexamtext?.description);
      const descMap = {};
      physicalExam.forEach((section) => {
      if (section.type && section.conditiontext) {
        descMap[section.type] = section.conditiontext;
      }
    });
    setSectionDescriptions(descMap); // <-- bind notes here
    setInitialDescriptions(descMap);
    } catch (error) {
      console.error("Error fetching Doctor Notes data:", error);
    } finally {
      dismissLoader();
    }
  };

  const fetchPhysicalExamMasterData = async () => {
    showLoader();
    try {
      const inputData = {
        input: { type: "physicalexam" },
      };
      const data = await GetDoctorMasterData(inputData.input);
      setDoctorMasterPhysicalExamData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dismissLoader();
    }
  };

  // Group data by examkey, subexamkey, and nestedexamkey
  const groupedData = doctorMasterPhysicalExamData.reduce((acc, item) => {
    const { examkey, subexamkey, nestedexamkey, examvalue, isindicator } = item;

    if (!acc[examkey]) acc[examkey] = {};
    if (subexamkey) {
      if (!acc[examkey][subexamkey]) acc[examkey][subexamkey] = {};
      if (nestedexamkey) {
        if (!acc[examkey][subexamkey][nestedexamkey])
          acc[examkey][subexamkey][nestedexamkey] = [];
        acc[examkey][subexamkey][nestedexamkey].push({
          examvalue,
          isindicator,
        });
      } else {
        if (!acc[examkey][subexamkey].items)
          acc[examkey][subexamkey].items = [];
        acc[examkey][subexamkey].items.push({ examvalue, isindicator });
      }
    } else {
      if (!acc[examkey].items) acc[examkey].items = [];
      acc[examkey].items.push({ examvalue, isindicator });
    }
    return acc;
  }, {});

  // console.log(groupedData);

  // const transformStateToAPIFormat = (selectedConditions) => {
  //   // Step 1: Group by examkey
  //   const groupedConditions = selectedConditions.reduce((acc, condition) => {
  //     const { examkey, subexamkey, nestedKey, indicator, examvalue } =
  //       condition;

  //     // If the examkey is not in the accumulator, add it
  //     if (!acc[examkey]) {
  //       acc[examkey] = [];
  //     }

  //     // Push the condition into the corresponding group
  //     acc[examkey].push({
  //       examvalue,
  //       subexamkey,
  //       nestedexamkey: nestedKey,
  //       indicator,
  //     });

  //     return acc;
  //   }, {});

  //   // Step 2: Convert to the required format
  //   const result = Object.keys(groupedConditions).map((examkey) => {
  //     return {
  //       id: null, // ID is always null
  //       type: examkey, // Use the examkey as the type
  //       value: groupedConditions[examkey], // The grouped value
  //     };
  //   });

  //   return result;
  // };
  const transformStateToAPIFormat = (selectedConditions) => {
    const groupedConditions = selectedConditions.reduce((acc, condition) => {
      const { examkey, subexamkey, nestedKey, indicator, examvalue } = condition;
  
      if (!acc[examkey]) acc[examkey] = [];
      acc[examkey].push({
        examvalue,
        subexamkey,
        nestedexamkey: nestedKey,
        indicator,
      });
  
      return acc;
    }, {});
  
    const result = Object.keys(groupedConditions).map((examkey) => ({
      id: null,
      type: examkey,
      value: groupedConditions[examkey],
      conditiontext: sectionDescriptions[examkey] || "",
    }));
  
    return result;
  };
  
  const UpdatePhysicalExam = async () => {
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        physicalexam: transformStateToAPIFormat(selectedConditions),
      },
    };
    showLoader();
    try {
      console.log(inputToSave);
      const result = await updateDoctorNotes(inputToSave.input);
      // console.log(result);
      if (result) {
        showSuccessToast("Physical Exam Saved successfully");
        fetchDoctorNotesEmptyIndication();
        // setChangesMade(false); // Reset changesMade state
        setSelectedConditions([]); // Reset selectedConditions
        fetchDoctorNotes();
      }
    } catch (error) {
      console.error("Error in Update Doctor Notes:", error);
      showErrorToast("Error Happened While Saving.");
    } finally {
      dismissLoader();
    }
  };

  //--------------------------------------------------------------------

  const [textFieldValue, setTextFieldValue] = useState("");
      const [defaultText, setDefaultText] = useState("");

  const UpdatePhysicalExamTextBox = async () => {
    const inputToSave = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        physicalexamtext: {
          description: textFieldValue,
          type: "other",
        },
      },
    };

    showLoader();
    try {
      const result = await updateDoctorNotes(inputToSave.input);
      if (result) {
        showSuccessToast("Physical Exam Saved successfully");
      }
    } catch (error) {
      console.error("Error in Update Doctor Notes:", error);
      showErrorToast("Error Happened While Saving.");
    } finally {
      dismissLoader();
    }
  };

  //--------------------------------------------
  // const activeTranscriber = useGPUTranscriber();
  //Remove speech and keep Null to toggle between GPU and Speech
  const { transcriber: activeTranscriber, mode } =
    useHybridTranscriber("speech", (text) => {
      // called when speech recognition finishes
      setPlaceholder(text || "");
      setTyping(false);
  });

  const [typing, setTyping] = useState(false); // Typing indicator state

  const [placeholder, setPlaceholder] = useState(
    "Click anywhere to start typing...."
  );

  useEffect(() => {
    // console.log("triggered");
    if (activeTranscriber?.output?.text) {
      setTextFieldValue(activeTranscriber.output.text);
      setDefaultText(activeTranscriber.output.text);
      setPlaceholder("Click anywhere to start typing....");
      setTyping(false);
    }
  }, [activeTranscriber?.output]);

  // submit on tab switch and submit button is enalbed
  useEffect(() => {
    if (submitOnTabSwitch) {
      if (textFieldValue && textFieldValue != defaultText) {
        UpdatePhysicalExamTextBox(); // Call the first save function if textFieldValue is not empty
      }
      if (
        !(initiallySelectedConditions === selectedConditions) &&
        selectedConditions.length &&
        actionAccessMain(20)?.create
      ) {
        UpdatePhysicalExam(); // Call the second save function based on its specific conditions
      }
    }
  }, [submitOnTabSwitch])
  
  const correctPhysicalExamText = async () => {
    // const inputToSave = {
    //   input: {
    //     text: textFieldValue,
    //   },
    // };
    const inputToSave = {
      input: {
        text: textFieldValue,
        type: "Physical Exam"
        // type: `physical_exam#${doctorSpecialties}#${noteType}#${doctorExperience}#${inpLang}#${outLang}`,
      },
    };
  
    showLoader();
    try {
      // const result = await CorrectChiefComplaintUsingAI(inputToSave.input);
      const result = await CorrectMedicalTermsUsingAI(inputToSave);
      if (result?.text) {
        showSuccessToast("Updated Physical Exam Text");
  
        const updatedText = result.text;
  
        setTextFieldValue(updatedText);        // ✅ update field
        aiModifiedRef.current = true;          // ✅ mark AI change
      }
    } catch (error) {
      console.error("Error in AI correction call:", error);
      // showErrorToast("Error Happened While Correcting.");
      showErrorToast("Error in Correct AI call.");
    } finally {
      dismissLoader();
    }
  };

  const isChatbotAllowed = () => {
  const subscriptionName = localStorage.getItem("subscriptionName");
  const subscriptionEndDate = localStorage.getItem("subscriptionEndDate");
  
  // If either value is missing, assume chatbot is allowed (or you can handle differently)
  if (!subscriptionName || !subscriptionEndDate) return true;
  
  // Check if subscription is Basic and end date has passed
  const currentDate = new Date();
  const endDate = new Date(subscriptionEndDate);
  
  // return !(subscriptionName === "Basic");
  return !(subscriptionName === "Basic" && currentDate > endDate);
};
  
  
  return (
    <Box
      // position="relative"
      height="100%"
      overflowY={"auto"}
      // display="flex"
      // flexDirection="column"
    >
      {isLoading && (
        <Box
          position="absolute"
          top="0"
          left="0"
          width="100%"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex="10"
          bg="rgba(255, 255, 255, 0.8)"
        >
          <Loader miniLoader={true} />
        </Box>
      )}
      <Accordion allowToggle>
        {Object.keys(groupedData).map((examkey) => (
          <AccordionItem key={examkey}>
            <h2>
              <AccordionButton
                _expanded={{ bg: "#e6e7e9", color: "black" }} // highlight selected button
              >
                <Box flex="1" textAlign="left">
                  {examkey}
                </Box>
              </AccordionButton>
            </h2>
            <AccordionPanel pb={2}>
              {Object.keys(groupedData[examkey]).map((subexamkey) =>
                subexamkey === "items" ? (
                  <Box key={subexamkey} mb={2}>
                    {/* Items without indicators */}
                    <Box maxWidth="100%" mb={2}>
                      {groupedData[examkey][subexamkey]
                        .filter((item) => item.isindicator === 0)
                        .map((item, idx) => (
                          <Box key={idx} display="inline-block" mr={1} mb={1}>
                            <ExamButton
                              item={item}
                              size={"xs"}
                              otherValues={{
                                examkey: examkey,
                                subexamkey:
                                  subexamkey !== "items" ? subexamkey : null,
                                nestedKey: null,
                                indicator: item.isindicator,
                                examvalue: item.examvalue,
                              }}
                              selectedConditions={selectedConditions}
                              setSelectedConditions={setSelectedConditions}
                            />
                          </Box>
                        ))}
                    </Box>

                    {/* Items with indicators */}
                    <Box maxWidth="100%" mt={0}>
                      {groupedData[examkey][subexamkey]
                        .filter((item) => item.isindicator !== 0)
                        .map((item, idx) => (
                          <Box key={idx} display="inline-block" mr={1} mb={1}>
                            <ExamButton
                              item={item}
                              size={"xs"}
                              otherValues={{
                                examkey: examkey,
                                subexamkey:
                                  subexamkey !== "items" ? subexamkey : null,
                                nestedKey: null,
                                indicator: item.isindicator,
                                examvalue: item.examvalue,
                              }}
                              selectedConditions={selectedConditions}
                              setSelectedConditions={setSelectedConditions}
                            />
                          </Box>
                        ))}
                    </Box>
                  </Box>
                ) : (
                  <Box key={subexamkey} mb={4}>
                    <Text
                      fontWeight="bold"
                      mb={2}
                      bg="#e6e7e9"
                      w="100%"
                      pl="8px"
                    >
                      {subexamkey}
                    </Text>
                    <Box>
                      {Object.keys(groupedData[examkey][subexamkey]).map(
                        (nestedKey) =>
                          nestedKey === "items" ? (
                            <Box key={nestedKey}>
                              {/* Items without indicators */}
                              <Box maxWidth="100%" mb={2}>
                                {groupedData[examkey][subexamkey][nestedKey]
                                  .filter((item) => item.isindicator === 0)
                                  .map((item, idx) => (
                                    <Box
                                      key={idx}
                                      display="inline-block"
                                      mr={1}
                                      mb={1}
                                    >
                                      <ExamButton
                                        item={item}
                                        size={"xs"}
                                        otherValues={{
                                          examkey: examkey,
                                          subexamkey:
                                            subexamkey !== "items"
                                              ? subexamkey
                                              : null,
                                          nestedKey:
                                            nestedKey !== "items"
                                              ? nestedKey
                                              : null,
                                          indicator: item.isindicator,
                                          examvalue: item.examvalue,
                                        }}
                                        selectedConditions={selectedConditions}
                                        setSelectedConditions={
                                          setSelectedConditions
                                        }
                                      />
                                    </Box>
                                  ))}
                              </Box>

                              {/* Items with indicators */}
                              <Box maxWidth="100%" mt={2}>
                                {groupedData[examkey][subexamkey][nestedKey]
                                  .filter((item) => item.isindicator !== 0)
                                  .map((item, idx) => (
                                    <Box
                                      key={idx}
                                      display="inline-block"
                                      mr={1}
                                      mb={1}
                                    >
                                      <ExamButton
                                        item={item}
                                        size={"xs"}
                                        otherValues={{
                                          examkey: examkey,
                                          subexamkey:
                                            subexamkey !== "items"
                                              ? subexamkey
                                              : null,
                                          nestedKey:
                                            nestedKey !== "items"
                                              ? nestedKey
                                              : null,
                                          indicator: item.isindicator,
                                          examvalue: item.examvalue,
                                        }}
                                        selectedConditions={selectedConditions}
                                        setSelectedConditions={
                                          setSelectedConditions
                                        }
                                      />
                                    </Box>
                                  ))}
                              </Box>
                             
                            </Box>
                          ) : null
                      )}
                    </Box>

                    <SimpleGrid columns={2} spacing={4}>
                      {Object.keys(groupedData[examkey][subexamkey]).map(
                        (nestedKey) =>
                          nestedKey !== "items" ? (
                            <Box key={nestedKey} mb={2}>
                              <Text
                                fontWeight="bold"
                                bg="white"
                                w="100%"
                                pl="8px"
                              >
                                {nestedKey}
                              </Text>
                              {/* Items without indicators */}
                              <Box mt='10px' p='14px' border='1px solid #e2e2e2' borderRadius='10px'>
                                <Box maxWidth="100%" mb={2}>
                                  {groupedData[examkey][subexamkey][nestedKey]
                                    .filter((item) => item.isindicator === 0)
                                    .map((item, idx) => (
                                      <Box
                                        key={idx}
                                        display="inline-block"
                                        mr={1}
                                        mb={1}
                                      >
                                        <ExamButton
                                          item={item}
                                          size={"xs"}
                                          otherValues={{
                                            examkey: examkey,
                                            subexamkey:
                                              subexamkey !== "items"
                                                ? subexamkey
                                                : null,
                                            nestedKey:
                                              nestedKey !== "items"
                                                ? nestedKey
                                                : null,
                                            indicator: item.isindicator,
                                            examvalue: item.examvalue,
                                          }}
                                          selectedConditions={selectedConditions}
                                          setSelectedConditions={
                                            setSelectedConditions
                                          }
                                        />
                                      </Box>
                                    ))}
                                </Box>

                                {/* Items with indicators */}
                                <Box maxWidth="100%">
                                  {groupedData[examkey][subexamkey][nestedKey]
                                    .filter((item) => item.isindicator !== 0)
                                    .map((item, idx) => (
                                      <Box
                                        key={idx}
                                        display="inline-block"
                                        // mr={1}
                                        // mb={1}
                                      >
                                        <ExamButton
                                          item={item}
                                          size={"xs"}
                                          otherValues={{
                                            examkey: examkey,
                                            subexamkey:
                                              subexamkey !== "items"
                                                ? subexamkey
                                                : null,
                                            nestedKey:
                                              nestedKey !== "items"
                                                ? nestedKey
                                                : null,
                                            indicator: item.isindicator,
                                            examvalue: item.examvalue,
                                          }}
                                          selectedConditions={selectedConditions}
                                          setSelectedConditions={
                                            setSelectedConditions
                                          }
                                        />
                                      </Box>
                                    ))}
                                </Box>
                               
                              </Box>
                            </Box>
                          ) : null
                      )}
                    </SimpleGrid>
                    
                  </Box>
                )
              )}
               <Box>
                  {/* <Text fontWeight="normal" mb={1}>Notes for {examkey}</Text> */}
                     <Textarea
                       placeholder={`Enter notes for ${examkey}`}
                       size="sm"
                       rows={2}
                       borderRadius="10px"
                       value={sectionDescriptions[examkey] || ""}
                       onChange={(e) =>
                          setSectionDescriptions((prev) => ({
                          ...prev,
                          [examkey]: e.target.value,
                        }))
                       }
                     />
                </Box>
            </AccordionPanel>
            
          </AccordionItem>
        ))}
      </Accordion>

      <Box
        padding={{ base: "0", md: "4" }}
        width={{ base: "100%", md: "98%" }}
        height="55%"
        // position={{ base: "unset", md: "absolute" }}
        bg="white"
        pt={"2px"}
      >
        <VStack spacing="4" height="85%">
          <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
            <Input
              value={textFieldValue}
              onChange={(e) => setTextFieldValue(e.target.value)}
              height="100%"
              padding="2"
              resize="none"
              as="textarea"
              disabled={typing} // Disable when AI typing is true
              style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
            />
            <Text
              position="absolute"
              bottom="2"
              left="50%"
              transform="translateX(-50%)"
              fontSize="sm"
              color="gray.500"
              w={{ base: "100%", md: "unset" }}
              textAlign={{ base: "center", md: "unset" }}
            >
              {placeholder}
            </Text>
          </Box>
          <HStack p={2} bottom="0" width="100%" alignItems="flex-end">
            {/* <GPUChatAudioManager
              transcriber={activeTranscriber}
              setPlaceholder={setPlaceholder}
              setTyping={setTyping}
            /> */}
            <GPUChatAudioManagerSpeechMode
                  transcriber={activeTranscriber}
                  mode={mode}
                  setPlaceholder={setPlaceholder}
                  setTyping={setTyping}
                />
            <Box
  as="button"
  border="1px solid #E6E7E9"
  borderRadius="full"
  w="36px"
  h="auto"
  p="10px"
  display="flex"
  justifyContent="center"
  alignItems="center"
  cursor={textFieldValue && isChatbotAllowed() ? "pointer" : "not-allowed"}
  opacity={textFieldValue && isChatbotAllowed() ? 1 : 0.5}
  pointerEvents={textFieldValue && isChatbotAllowed() ? "auto" : "none"}
  onClick={() => 
    textFieldValue && isChatbotAllowed() && correctPhysicalExamText()
  }
  bg={isChatbotAllowed() ? "transparent" : "gray.100"}
  _hover={
    textFieldValue && isChatbotAllowed() 
      ? { bg: "gray.50", borderColor: "gray.300" } 
      : {}
  }
  title={
    !isChatbotAllowed() 
      ? "Please upgrade your subscription to use AI features"
      : !textFieldValue
      ? "Please enter text to enable AI suggestions"
      : "Get AI suggestions"
  }
>
  <Image 
    w="26px" 
    src="/assets/svgs/ai-star-outline.svg" 
    opacity={textFieldValue && isChatbotAllowed() ? 1 : 0.5}
    filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
  />
</Box>
           {/* <Box
            as="button"
            border="1px solid #E6E7E9"
            borderRadius="full"
            w="36px"
            h="auto"
            p="10px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            cursor={textFieldValue ? "pointer" : "not-allowed"}
            opacity={textFieldValue ? 1 : 0.5}
            pointerEvents={textFieldValue ? "auto" : "none"}
            onClick={() => textFieldValue && correctPhysicalExamText()}
          >
            <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
          </Box> */}

            <PrimaryButton
              buttonText="Save Physical Exam"
              // onClick={UpdatePhysicalExam}
              onClick={() => {
                const hasTextFieldChanged = textFieldValue && textFieldValue !== defaultText;
                const isTextModified = textFieldValue !== defaultText || aiModifiedRef.current;
                const hasSectionDescriptionsChanged = Object.keys(sectionDescriptions).some(
                  (key) => sectionDescriptions[key] !== initialDescriptions[key]
                );
              
                if (isTextModified) {
                  UpdatePhysicalExamTextBox();
                  aiModifiedRef.current = false; 
                }
              
                if (
                  (
                    initiallySelectedConditions !== selectedConditions ||
                    hasSectionDescriptionsChanged
                  ) &&
                  selectedConditions.length &&
                  actionAccessMain(20)?.create
                ) {
                  UpdatePhysicalExam();
                }
              }}
              // onClick={() => {
              //   if (textFieldValue) {
              //     UpdatePhysicalExamTextBox(); // Call the first save function if textFieldValue is not empty
              //   }
              //   if (
              //     !(initiallySelectedConditions === selectedConditions)  &&
              //     selectedConditions.length &&
              //     actionAccessMain(20)?.create
              //   ) {
              //     UpdatePhysicalExam(); // Call the second save function based on its specific conditions
              //   }
              // }}
              // isDisabled={
              //   initiallySelectedConditions === selectedConditions ||
              //   !selectedConditions.length ||
              //   !actionAccessMain(20)?.create
              // }
              btnStyle={{
                h: "2.5rem",
                w: "90%",
                p: "0",
                // mr: "12px",
                // ml: "12px",
                // position: "sticky",
                // bottom: "0",
                // mt: "3rem",
                mx: "2.5%",
                zIndex: "1",
                bg: COLORS.PRIMARY_GRADIENT,
                color: COLORS.PRIMARY_WHITE,
                _hover: { bg: COLORS.PRIMARY_COLOR },
              }}
            />
          </HStack>
        </VStack>
      </Box>
    </Box>
  );
};

const ExamButton = ({
  item,
  size = "sm",
  otherValues,
  selectedConditions,
  setSelectedConditions,
}) => {
  // console.log(otherValues);

  const { examvalue, isindicator } = item;

  const [isSelected, setIsSelected] = useState(() => {
    return selectedConditions.some(
      (condition) =>
        condition.examvalue === examvalue &&
        condition.nestedKey === otherValues.nestedKey &&
        condition.subexamkey === otherValues.subexamkey &&
        condition.examkey === otherValues.examkey
    );
  });

  // State to track selection status for different values
  const [selectedValue, setSelectedValue] = useState(null);

  // State to track selection of the center, plus, and minus buttons
  // const [selected, setSelected] = useState("");
  // Initialize the selected state based on the existing selectedConditions
  const initialSelected =
    selectedConditions.find(
      (condition) =>
        condition.examvalue === examvalue &&
        condition.nestedKey === otherValues.nestedKey &&
        condition.subexamkey === otherValues.subexamkey &&
        condition.examkey === otherValues.examkey
    )?.indicator || "";

  // Set the initial selected state based on the indicator (-1, 0, 1)
  const [selected, setSelected] = useState(() => {
    // If indicator is 1, set selected as "+"
    // If indicator is -1, set selected as "-"
    // If indicator is 0 or null, set selected as "-"
    if (initialSelected === 1) {
      return "+";
    } else if (initialSelected === -1) {
      return "-";
    } else {
      return "";
    }
  });

  const handleSelectCenter = (value) => {
    setSelected((prev) => {
      const isToggledOff = prev === "center";
      const updatedIndicator = isToggledOff ? null : 0;
      const updatedConditions = isToggledOff
        ? selectedConditions.filter(
            (condition) => condition.examvalue !== examvalue
          )
        : [
            ...selectedConditions,
            { ...otherValues, indicator: updatedIndicator },
          ];

      setSelectedConditions(updatedConditions);
      return isToggledOff ? "" : value;
    });
  };

  const handleSelectPlusIndicator = (value) => {
    setSelected((prev) => {
      // Early return if `prev` is "-"
      if (prev === "-") {
        const conditionIndex = selectedConditions.findIndex(
          (condition) =>
            condition.examvalue === examvalue &&
            condition.nestedKey === otherValues.nestedKey &&
            condition.subexamkey === otherValues.subexamkey &&
            condition.examkey === otherValues.examkey
        );

        const updatedConditions = [...selectedConditions];

        if (conditionIndex !== -1) {
          // Update the existing condition's indicator
          updatedConditions[conditionIndex] = {
            ...updatedConditions[conditionIndex],
            indicator: 1,
          };
        } else {
          // Add the condition if it doesn't exist
          updatedConditions.push({ ...otherValues, indicator: 1 });
        }

        setSelectedConditions(updatedConditions);
        return value;
      }

      const isToggledOff = prev === "+";
      const updatedIndicator = isToggledOff ? null : 1;
      const updatedConditions = isToggledOff
        ? selectedConditions.filter(
            (condition) =>
              condition.examvalue !== examvalue &&
              condition.nestedKey !== otherValues.nestedKey &&
              condition.subexamkey !== otherValues.subexamkey &&
              condition.examkey !== otherValues.examkey
          )
        : [
            ...selectedConditions,
            { ...otherValues, indicator: updatedIndicator },
          ];

      setSelectedConditions(updatedConditions);
      return isToggledOff ? "" : value;
    });
  };

  const handleSelectMinusIndicator = (value) => {
    setSelected((prev) => {
      // Early return if `prev` is "+"
      if (prev === "+") {
        const conditionIndex = selectedConditions.findIndex(
          (condition) =>
            condition.examvalue === examvalue &&
            condition.nestedKey === otherValues.nestedKey &&
            condition.subexamkey === otherValues.subexamkey &&
            condition.examkey === otherValues.examkey
        );

        const updatedConditions = [...selectedConditions];

        if (conditionIndex !== -1) {
          // Update the existing condition's indicator
          updatedConditions[conditionIndex] = {
            ...updatedConditions[conditionIndex],
            indicator: -1,
          };
        } else {
          // Add the condition if it doesn't exist
          updatedConditions.push({ ...otherValues, indicator: -1 });
        }

        setSelectedConditions(updatedConditions);
        return value;
      }

      const isToggledOff = prev === "-";
      const updatedIndicator = isToggledOff ? null : -1;
      const updatedConditions = isToggledOff
        ? selectedConditions.filter(
            (condition) =>
              condition.examvalue !== examvalue &&
              condition.nestedKey !== otherValues.nestedKey &&
              condition.subexamkey !== otherValues.subexamkey &&
              condition.examkey !== otherValues.examkey
          )
        : [
            ...selectedConditions,
            { ...otherValues, indicator: updatedIndicator },
          ];

      setSelectedConditions(updatedConditions);
      return isToggledOff ? "" : value;
    });
  };

  const handleNormalButtonClick = () => {
    setIsSelected(!isSelected);
    setSelectedConditions((prevConditions) => {
      const conditionExists = prevConditions.some(
        (condition) =>
          condition.examvalue === examvalue &&
          condition.nestedKey === otherValues.nestedKey &&
          condition.subexamkey === otherValues.subexamkey &&
          condition.examkey === otherValues.examkey
      );

      if (conditionExists) {
        // Remove the condition if it already exists
        return prevConditions.filter(
          (condition) =>
            condition.examvalue !== examvalue &&
            condition.nestedKey !== otherValues.nestedKey &&
            condition.subexamkey !== otherValues.subexamkey &&
            condition.examkey !== otherValues.examkey
        );
      } else {
        // Add the condition with indicator as null
        return [...prevConditions, { ...otherValues, indicator: null }];
      }
    });
  };

  return isindicator === 0 ? (
    <Button
      key={examvalue}
      borderRadius="full"
      onClick={handleNormalButtonClick}
      bg={isSelected ? "black" : "white"}
      color={isSelected ? "white" : "black"}
      leftIcon={
        isSelected ? (
          <Image src="/assets/svgs/white-ok.svg" boxSize="1em" />
        ) : null
      }
      variant="solid"
      border={isSelected ? "none" : "1px solid #E6E7E9"}
      size={size}
      boxShadow={isSelected ? "none" : "0px 2px 3px rgba(0, 0, 0, 0.2)"}
      _hover={{
        bg: isSelected ? "black" : 'white', // Darker when hovered
      }}
      _active={{
        bg: isSelected ? "black" : 'white', // Slightly dim when clicked
      }}
      m={1}
      // isDisabled={isSelected} // Disable button if it's prepopulated
    >
      {examvalue}
    </Button>
  ) : (
    <HStack
      spacing={0}
      border="1px solid #e2e2e2"
      borderRadius="md"
      p='0.25rem 0.5rem'
      alignItems="center"
      color={selected === "-" ? "white" : selected === "+" ? "white" : "black"}
      bg={
        selected === "-"
          ? "#F56565"
          : selected === "+"
            ? "#48bb78"
            : selected === "center"
              ? "white"
              : selected === ""
                ? "white"
                : "transparent"
      }
    >
      {/* Plus button */}
      {/* <Text
        as="button"
        // onClick={() => handleSelectCorner("+")}
        onClick={() => handleSelectPlusIndicator("+")}
        color={selected === "+" ? "white" : "black"}
        bg={selected === "+" ? "#f55b47" : "transparent"}
        borderRadius="md"
        p={1}
        _hover={{ cursor: "pointer" }}
      >
        +
      </Text> */}
      <Box as="button" onClick={() => handleSelectPlusIndicator("+")} >
        <FaPlus style={{width:'14px', height:'auto'}} />
      </Box>

      {/* Center button */}
      <Button
        variant="solid"
        size={size}
        // onClick={() => handleSelectCenter("center")}
        bg={
          selected === "center"
            ? "black"
            : selected === "+"
              ? "#48bb78"
              : selected === "-"
                ? "#F56565"
                : "white"
        }
        color={selected ? "white" : "black"}
        _hover={{
          bg:
          selected === "center"
            ? "black"
            : selected === "+"
              ? "#48bb78"
              : selected === "-"
                ? "#F56565"
                : "white",
          color: selected ? "white" : "black", // Disable hover text color change
        }}
      >
        {examvalue}
      </Button>

      {/* Minus button */}
      {/* <Text
        as="button"
        onClick={() => handleSelectMinusIndicator("-")}
        // onClick={() => handleSelectCorner("-")}
        color={selected === "-" ? "white" : "black"}
        bg={selected === "-" ? "#f5a947" : "transparent"}
        borderRadius="md"
        p={1}
        _hover={{ cursor: "pointer" }}
      >
        -
      </Text> */}
      <Box as='button' onClick={() => handleSelectMinusIndicator("-")}>
        <FiMinus style={{width:'14px', height:'auto'}} />
      </Box>
    </HStack>
  );
};

export default DoctorPhysicalExamCard;
